import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err);
}

const routes = [
  {
    path: '/:meeting_id',
    name: 'Layout',
    redirect: '/hall/:meeting_id',
    component: () => import('@/views/layout'),
    children: [
      {
        path: '/hall/:meeting_id',
        name: 'Hall',
        meta:{
          title:'会场列表',
          auth:true,
        },
        component: () => import(/* webpackChunkName: "Index" */ '@/views/layout/hall.vue')
      },
      {
        path: '/sms-list/:meeting_id/:hall_id',
        name: 'SmsList',
        meta:{
          title:'消息通知',
          auth:true,
        },
        component: () => import(/* webpackChunkName: "SmsList" */ '@/views/layout/sms-list.vue')
      },
      {
        path: '/person/:meeting_id/:hall_id',
        name: 'Person',
        meta:{
          title:'人员列表',
          auth:true,
        },
        component: () => import(/* webpackChunkName: "Person" */ '@/views/layout/person.vue')
      },
      {
        path: '/area/:meeting_id/:hall_id',
        name: 'Area',
        meta:{
          title:'座位管理',
          auth:true,
        },
        component: () => import(/* webpackChunkName: "Area" */ '@/views/layout/area.vue')
      },
      {
        path: '/setting/:meeting_id',
        name: 'Setting',
        meta:{
          title:'其他设置',
          auth:true,
        },
        component: () => import(/* webpackChunkName: "Setting" */ '@/views/layout/setting.vue')
      },
    ],
  },
  {
    path: '/searchseat/:meeting_id/:hall_id?',
    name: 'Searchseat',
    meta:{
      title:'座位查询',
    },
    component: () => import(/* webpackChunkName: "Searchseat" */ '@/views/searchseat.vue')
  },
  {
    path: '/preview/:meeting_id',
    name: 'Preview',
    meta:{
      title:'座位预览',
    },
    component: () => import(/* webpackChunkName: "Preview" */ '@/views/preview.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})

export default router
